let currMovie = {}, prevMovie = null;
const videoControl = (str) => {
    if(!currMovie[str.id]){
        currMovie[str.id] = promokit.video({
            el:`#${str.id}`,
            url:`${str.video}`,
            loop:true,
            controls:false
        });
    };
    prevMovie && prevMovie.stop();
    currMovie[`${str.id}`].play();
    prevMovie = currMovie[`${str.id}`];
};

export default videoControl;


// WEBPACK FOOTER //
// ./src/js/create/video-control.js